import { useLayoutEffect, useRef } from 'react'
import { motion } from '@/utils/motion'

interface AnimatedNumberProps {
  value: number
  format?: (value: number) => string
  className?: string
}

/**
 * A figure that counts from its last value to the new one instead of snapping,
 * so a slider move reads as a change of degree. The text is written to the DOM
 * during the tween; the rendered child is the settled value for SSR and tests.
 */
export function AnimatedNumber({ value, format = (v) => `${Math.round(v)}`, className }: AnimatedNumberProps) {
  const ref = useRef<HTMLSpanElement>(null)
  const shown = useRef(value)

  useLayoutEffect(() => {
    const el = ref.current
    const from = shown.current
    shown.current = value
    if (!el || from === value) return
    void motion.tween((t) => {
      el.textContent = format(from + (value - from) * t)
    }, { ms: 520, key: el })
  }, [value, format])

  return (
    <span ref={ref} className={className}>
      {format(value)}
    </span>
  )
}
